import { render, staticRenderFns } from "./CreateOrganisationView.vue?vue&type=template&id=dd8d4700&scoped=true"
import script from "./CreateOrganisationView.vue?vue&type=script&lang=js"
export * from "./CreateOrganisationView.vue?vue&type=script&lang=js"
import style0 from "./CreateOrganisationView.vue?vue&type=style&index=0&id=dd8d4700&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd8d4700",
  null
  
)

export default component.exports